/**
 * Icon Tabs
 */
angular.module('elogbooksDirectives').directive('iconTabs', ['$http', 'apiClient', '$state', function ($http, apiClient, $state) {
    return {
        restrict: 'AE',
        transclude: true,
        scope: true,
        replace: true,
        templateUrl: '/modules/directives/layout/icon-tabs/icon-tabs.html'
    };
}]);
